export const flattenObject = (obj, prefix = '') => {
  const result = {};
  Object.entries(obj || {}).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenObject(value, path));
    } else {
      result[path] = value;
    }
  });
  return result;
};

export const unflattenObject = (flat) => {
  const result = {};
  Object.entries(flat).forEach(([path, value]) => {
    const keys = path.split('.');
    let cursor = result;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        cursor[key] = value;
      } else {
        cursor[key] = cursor[key] || {};
        cursor = cursor[key];
      }
    });
  });
  return result;
};
